import { useEffect } from 'react';

interface CourseForumHelpModalProps {
  open: boolean;
  onClose: () => void;
}

export function CourseForumHelpModal({ open, onClose }: CourseForumHelpModalProps) {
  useEffect(() => {
    if (!open) return;

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="lms-course-forum-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="course-forum-help-title"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="lms-course-forum-modal__panel">
        <div className="lms-course-forum-modal__head">
          <h3 id="course-forum-help-title" className="lms-course-forum-modal__title">
            ¿Cómo participar?
          </h3>
          <button
            type="button"
            className="lms-course-forum-modal__close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            <span className="material-symbols-outlined" aria-hidden="true">
              close
            </span>
          </button>
        </div>
        <div className="lms-course-forum-modal__body lms-course-forum-help">
          <p>
            El foro usa un alias anónimo para proteger tu identidad frente a otros estudiantes. Los
            docentes pueden ver tu nombre real para moderar y orientar el curso.
          </p>
          <ul>
            <li>Formula dudas conceptuales relacionadas con las unidades del curso.</li>
            <li>Comparte recursos de apoyo y enlaces útiles con tus compañeros.</li>
            <li>Mantén un tono respetuoso y constructivo en los debates.</li>
            <li>Revisa si ya existe un hilo similar antes de publicar uno nuevo.</li>
          </ul>
        </div>
        <div className="lms-course-forum-modal__footer">
          <button type="button" className="lms-course-forum-modal__btn-primary" onClick={onClose}>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}
